import { useEffect } from 'react';

// @ts-expect-error - PageLayout doesn't have TypeScript definitions
import PageLayout from 'src/components/PageLayout';
import { getQueryParamSingleValue } from 'src/lib/browser';
import { useHistory } from 'src/lib/hooks';
import { ROUTE_PARAMS, ROUTES } from 'src/routes';
// @ts-expect-error - useNotificationActions is not typed yet
import { useNotificationActions } from 'src/store/notification';

import { ConsentForm } from './views/ConsentForm';
import { ErrorCard } from './views/ErrorCard';
import { LoadingCard } from './views/LoadingCard';
import { usePageActions } from './store';
import { useStyles } from './useStyles';
import { useViewState } from './useViewState';

const getReturnTo = (): string | undefined =>
  getQueryParamSingleValue(ROUTE_PARAMS.oauth2Consent) ||
  getQueryParamSingleValue(ROUTE_PARAMS.returnTo);

export const OAuthConsentPage = () => {
  const styles = useStyles();
  const history = useHistory();
  const pageActions = usePageActions();
  const notificationActions = useNotificationActions();
  const {
    approving,
    appDisplayName,
    appNameLoading,
    appNameError,
    copilotAccountName,
    copilotWorkspaceName,
    infoLoading,
  } = useViewState();

  const returnTo = getReturnTo();

  useEffect(() => {
    if (!returnTo) {
      history.replace(ROUTES.ROOT);
      return;
    }
    pageActions.initPage(returnTo);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!returnTo) return null;

  const goToSignIn = () => history.replace(ROUTES.SIGN_IN);

  const handleApprove = async () => {
    const redirectUrl = await pageActions.approve();
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      notificationActions.displayError(new Error('Authorization failed. Please try again.'));
    }
  };

  const isLoading = appNameLoading || infoLoading;

  const renderContent = () => {
    if (isLoading) return <LoadingCard message="Loading application…" />;
    if (appNameError || !appDisplayName) {
      return (
        <ErrorCard
          message={appNameError || 'Application not found.'}
          onBack={goToSignIn}
        />
      );
    }
    return (
      <ConsentForm
        appDisplayName={appDisplayName}
        approving={approving}
        copilotAccountName={copilotAccountName}
        copilotWorkspaceName={copilotWorkspaceName}
        onApprove={handleApprove}
        onDeny={goToSignIn}
      />
    );
  };

  return (
    <PageLayout className={styles.root}>
      <div className={styles.card}>{renderContent()}</div>
    </PageLayout>
  );
};
